import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

const images = require.context('../images', true)

window.jQuery = window.$ = require('jquery')
import './jquery.jpostal.js'
import './user_form.js'
import './supporter-ajax.js'
import '@fortawesome/fontawesome-free/js/fontawesome.min';
import './bootstrap_custom.js'

import "../stylesheets/application"

Rails.start()
Turbolinks.start()
ActiveStorage.start()
